// extracted by mini-css-extract-plugin
export var auto = "_37-1";
export var spinner = "_37-0";